import { render, staticRenderFns } from "./PeopleCrud.vue?vue&type=template&id=5b71e8f3"
import script from "./PeopleCrud.vue?vue&type=script&lang=js"
export * from "./PeopleCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports